import { getScheduleKeyFromDate, sendScheduleOptions, type SendScheduleKey } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { Body } from '~/components/typography/Content'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils'

export function FeedbackScheduleButtons({
  selectedTime,
  onSelectTime,
  disabled,
  description,
  referenceDate,
  className,
}: {
  selectedTime: SendScheduleKey | Date | null
  onSelectTime: (sendAt: Date, scheduleKey: SendScheduleKey) => void
  disabled?: boolean
  description?: string
  referenceDate?: Date
  className?: string
}) {
  const { t } = useTranslations('feedback')

  const selectedTimeKey =
    typeof selectedTime === 'string'
      ? selectedTime
      : getScheduleKeyFromDate(selectedTime ?? new Date())

  /* const labels = useMemo(
    () => ({
      now: ,
      one_hour: t(($) => $.requestFlow.sendScheduleOptions.one_hour),
      next_morning: t(($) => $.requestFlow.sendScheduleOptions.next_morning),
    }),
    [t]
  ) */

  return (
    <View className={cn('gap-4', className)}>
      <Body className="mb-2 text-pretty px-4 text-center">
        {description ?? t(($) => $.requestFlow.scheduleButtonDescription)}
      </Body>
      <View className={cn('flex-row flex-wrap items-center justify-center gap-3')}>
        {sendScheduleOptions.map((option) => (
          <Button
            key={option.key}
            variant={selectedTimeKey === option.key ? 'default' : 'outline'}
            size="sm"
            onPress={() => {
              const sendAt = option.value(referenceDate ?? new Date())
              onSelectTime(sendAt, option.key)
            }}
            disabled={disabled}>
            {t(($) => $.requestFlow.sendScheduleOptions[option.key])}
          </Button>
        ))}
      </View>
    </View>
  )
}
